import io from 'socket.io-client';

/*class Socket {
  url = 'http://localhost:3001';
  client = null;
  constructor() {
    this.client = io.connect(this.url);
  }
  addToken(token) {
    this.client = io.connect(this.url, { query: { token } });
  }
  removeToken() {
    this.client = io.connect(this.url);
  }
}*/

class Socket {
  constructor() {
    // ⬇️ same ngrok URL as above (https)
    const NGROK = 'https://discussed-watches-kevin-anime.trycloudflare.com';
    this.url =
      (typeof window !== 'undefined' && window.location.hostname === 'localhost')
        ? 'http://localhost:3001'
        : NGROK;

    this.client = io(this.url, { transports: ['websocket'] });
  }

  addToken(token) {
    this.client = io(this.url, { query: { token }, transports: ['websocket'] });
  }

  removeToken() {
    this.client = io(this.url, { transports: ['websocket'] });
  }
}


const instance = new Socket();

export default instance;
